import { createContext } from "react";

import type { KillswitchContext } from "./types";

export const Context = createContext<KillswitchContext>({
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  addKillswitch: () => {},
  getKillswitch: () => undefined,
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  removeKillswitch: () => {},
});
